import { defineMessage } from 'react-intl';
import { getDisplayInformation } from './get-display-information';
import { getSanitizedName } from './name-utils';

const unknownCarrier = defineMessage({
  description: 'dataDrivenLogos.unknownCarrier',
  defaultMessage: 'Unknown Carrier',
  id: 'gfa9Od',
});

export const getProviderDisplayName = (id, sanitizeBranding = false) => {
  const providerId = Number.parseInt(id, 10);
  const displayInformation = getDisplayInformation({ providerId }) || {};

  if (!displayInformation.name) {
    return unknownCarrier;
  }

  const name = sanitizeBranding ? getSanitizedName(displayInformation.name) : displayInformation.name;

  return { id: 'provider.dynamic', defaultMessage: name };
};
